import api from '../common/services/liferay/api';
import {Liferay as LiferayAPI} from '../common/services/liferay/liferay';
import { logger, filtrarAreasPorCoordenadas } from './Utils';

	function usarQuery() {
		const search = document.location.search;
	
		return new URLSearchParams(search);
	}

	export function traducir(variableTraducciones){
		var langActual=LiferayAPI.ThemeDisplay.getLanguageId();
		var texto="";
		switch (langActual) {
            case 'es_ES':
            	texto= variableTraducciones?.es_ES;
				break;
            case 'en_US':
				texto= variableTraducciones?.en_US;
				break;
            case 'ca_ES':
				texto= variableTraducciones?.ca_ES;
				break;
            case 'eu_ES':
				texto= variableTraducciones?.eu_ES;
				break;
            case 'gl_ES':
				texto= variableTraducciones?.gl_ES;
				break;
			case 'de_DE':
				texto= variableTraducciones?.de_DE;
				break;
			case 'fr_FR':
				texto= variableTraducciones?.fr_FR;
				break;
			case 'it_IT':
				texto= variableTraducciones?.it_IT;
				break;
			case 'pt_PT':
				texto= variableTraducciones?.pt_PT;
				break;
            default:
            	return undefined ;
        }

		if(texto && texto!=""){
			return texto;
		} else{
			return variableTraducciones?.es_ES;
		}
	}

	export async function getTraducciones(){
		var promesa= await api('o/c/literalbuscadors/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId()+'?pageSize=50')
		.catch((e) => console.error("Error en llamada traducciones: " + e));
		var final=await promesa.json();
		return final.items[0]; 
	}

	export async function getAeropuertos(){
		var resultado={};
		var pagina=1;
		var paginaMax=5;
		var tamPagina=50;
		while(pagina<paginaMax){
			var promesa= await api('o/c/estacions/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId()+'?page='+pagina+'&pageSize='+tamPagina)
			.catch((e) => console.error("Error en llamada aeropuertos: " + e));
			var final=await promesa.json();
			if(final){
				paginaMax=final.lastPage;
				pagina=pagina+1;
				resultado={
					...resultado,
					...final
				};
			} else{
				console.error("Error en llamada aeropuertos paginacion");
				break;
			}
		}
		return resultado;
	}

	export async function getTarifas(){
		var promesa= await api('o/c/tarifas/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId()+'?pageSize=50')
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		return promesa.json();
		//TODO cambiar fecha utc por local
	}

	export async function getApiKeyTomTom() {
		var promesa = await api('o/c/configuracions/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId())
		.catch((e) => console.error("Error en llamada API key: " + e));
		var final=await promesa.json();
		return final.items[0].apiKey; 
	}

	export async function getConfiguracionUrl() {
		var promesaUrl = await api('o/c/configuracions/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId())
		.catch((e) => console.error("Error en llamada url formulario: " + e));
		return promesaUrl.json();
	}

	export async function getConfiguracionesBuscador() {
		var promesaUrl = await api('o/c/configuracions/scopes/' + LiferayAPI.ThemeDisplay.getScopeGroupId())
			.catch((e) => console.error("Error en llamada url formulario: " + e));
		var final = await promesaUrl.json();
		var url = {
			'buscadorPlazoDefectoHora': final.items[0].buscadorPlazoDefectoHora,
			'buscadorPlazoDefectoMinutos': final.items[0].buscadorPlazoDefectoMinutos,
			'buscadorPeriodoGraciaHoras': final.items[0].buscadorPeriodoGraciaHoras,
			'buscadorPeriodoGraciaMinutos': final.items[0].buscadorPeriodoGraciaMinutos,
			'buscadorPlazoMinimoHora': final.items[0].buscadorPlazoMinimoHora,
			'buscadorPlazoMinimoMinutos': final.items[0].buscadorPlazoMinimoMinutos,
			'configuracionBusqueda':final.items[0].configuracionBusqueda
		}
		return url;
	}

	export async function getImagenFondo() {
		var promesa = await api('o/c/configuracions/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId())
		.catch((e) => console.error("Error en llamada url formulario: " + e));
		var final=await promesa.json();
		if(final.items[0].imagenFondoBuscador){
			return final.items[0].imagenFondoBuscador.link.href
		}
		return undefined; 
	}

	export async function getUrlFormulario(origen,dest,origenAeropuerto,fechaIda,pasajeros,fechaVuelta=undefined) {
		var resp=await getConfiguracionUrl();
		var url;
		for await (let conf of resp.items) {
			url= conf.urlFormulario;
		}
		
		let strPlaceId="";
		let strKey="";
		let strCambio="";
		let strVuelta="";
		if(dest.place_id!=="" && dest.place_id){
			strPlaceId="&place_id="+dest.place_id;
		}
		if(dest.key!=="" && dest.key){
			strKey="&destination="+dest.key;
		}
		if(!origenAeropuerto){
			strCambio="&origenNoAeropuerto="+!origenAeropuerto;
		}
		if(fechaVuelta){
			strVuelta="&fechaVuelta="+fechaVuelta.toISOString();
		}
		url+="?aeropuertoId="+origen.id+"&type="+dest.type+"&fechaIda="+fechaIda.toISOString()+strVuelta+strPlaceId+strKey
		+"&pasajeros="+pasajeros.adultos+"&ninos="+pasajeros.ninos+"&bebes="+pasajeros.bebes+strCambio;
		logger(url);
		return url;
	}

    
	export async function getTarifasAeropuerto(idAeropuerto){
		var promesa= await api('o/c/estacions/'+ idAeropuerto+"/estacion")
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		return promesa.json();
	}

	export async function getTarifasByPrecioArea(idPrecio){
		var promesa= await api('o/c/preciotarifasareas/'+ idPrecio+"/precioTarifasArea?pageSize=50")
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		return promesa.json();
	}

	export async function getLocalizacionById(idTarifa){
		var promesa= await api('o/c/localizacions/'+ idTarifa)
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		return promesa.json();
	}

	export async function getLocalizaciones(){
		var promesa= await api('o/c/localizacions/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId())
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		return promesa.json();
	}

	export async function getAreas(){
		var promesa= await api('o/c/areas/scopes/'+ LiferayAPI.ThemeDisplay.getScopeGroupId()+'?pageSize=500')
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		return promesa.json();
	}

	export async function getPrecioAreaByArea(idArea){
		var promesa= await api('o/c/areas/'+ idArea+"/areaPrecio?pageSize=50")
		.catch((e) => console.error("Error en llamada preciosareabyarea: " + e));
		return promesa.json();
	}

	/*
	export async function getPlaceById(placeId){
		var clave= await getApiKeyTomTom();
		var results = await tt.services.placeById({
			entityId: placeId,
			key: clave
		})
		.catch((e) => window.alert("Geocoder failed due to: " + e));

		if(results.results.length==0){
			window.alert("No hay resultados para ese placeID");
			return;
		}

		return results.results;
	}*/

	/*
	export async function getLocalizacionesTarifa(tarifaId){
		var promesa= await api('o/c/tarifas/'+ tarifaId+"/precioTarifasLocalizacion?pageSize=50")
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		var jsonRespuesta= await promesa.json();
		var listaLocals=[];
		for await (let precioLocal of jsonRespuesta.items) {
			var respuesta2 = await api('o/c/tarifalocprecios/'+ precioLocal.id+"/localizacion")
			.catch((e) => console.error("Error en llamada tarifas: " + e));
			var jsonRespuesta2= await respuesta2.json();

			jsonRespuesta2.items.forEach((local)=>{
				var elemento={
					id: local.id,
					key:local.localizacionSelect.key,
					nombre:local.localizacionSelect.name,
					precio: precioLocal.precio
				};
				listaLocals.push(elemento);
			});

		}
		return listaLocals;
	}
	*/

	/*
	export async function getAreasTarifa(tarifaId){
		var promesa= await api('o/c/tarifas/'+ tarifaId+"/precioTarifasArea?pageSize=50")
		.catch((e) => console.error("Error en llamada areas: " + e));

		var respuesta= await promesa.json();

		var listaAreas=[];
		for await (let precioArea of respuesta.items) {
			var promesa= await api('o/c/preciotarifasareas/'+ precioArea.id+"/area?fields=id%2Cnombre%2Ccoordenadas")
			.catch((e) => console.error("Error en llamada tarifas: " + e));
			var respuesta2= await promesa.json();

			respuesta2.items.forEach((area)=>{
				var elemento={
					id: area.id,
					nombre:area.nombre,
					precio: precioArea.precio,
					precioFinDeSemana: precioArea.precioFinDeSemana,
					precioNocturno: precioArea.precioNocturno,
					precioPorKm:precioArea.precioPorKm,
					coordenadas:area.coordenadas,
					prioridad: area.prioridad
				};
				listaAreas.push(elemento);
			});

		}
		return listaAreas;
	}*/

	export async function getTodoAeropuertoNested(id){
		var listaTarifasTemp=[];
		var aero;
		//http://spaintransfers.es:8080/o/c/aeropuertos/66667003?nestedFields=aeropuerto,precioTarifasArea,precioTarifasLocalizacion,area,localizacion&nestedFieldsDepth=3
		var promesa= await api("o/c/estacions/"+id+"?nestedFields=estacion,precioTarifasArea,precioTarifasLocalizacion,area,localizacion&nestedFieldsDepth=3")
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		var resultado= await promesa.json();
		logger(resultado);

		for(let tarifa of resultado.estacion){
			var respuestaLocalizaciones=[];
			var respuestaAreas=[];
			if(resultado.localizaciones){
				for(let precioLocal of tarifa.precioTarifasLocalizacion){
					for(let local of precioLocal.localizacion){
						var elemento={
							id: local.id,
							key:local.localizacionSelect.key,
							nombre:local.localizacionSelect.name,
							precio: precioLocal.precio,
							textoBusqueda:local.textoBusqueda

						};
						respuestaLocalizaciones.push(elemento);
					}
				}
			}
			if(resultado.airport2Door){
				
				for (let precioArea of tarifa.precioTarifasArea) {
					for (let area of precioArea.area) {
						let elemento={
							id: area.id,
							nombre: area.nombre,
							precio: precioArea.precio,
							precioFinDeSemana: precioArea.precioFinDeSemana,
							precioNocturno: precioArea.precioNocturno,
							precioPorKm: precioArea.precioPorKm,
							coordenadas: area.coordenadas,
							prioridad: area.prioridad
						};
						respuestaAreas.push(elemento);
					}
				}
			}

            var tarifaLocalizaciones={
                ...tarifa,
                localizacionesConPrecios: respuestaLocalizaciones,
                areasConPrecios: respuestaAreas
                }
            listaTarifasTemp.push(tarifaLocalizaciones);
		}

		aero={
			id: resultado.id,
			nombre: traducir(resultado.nombre_i18n)?traducir(resultado.nombre_i18n):'',
			place_id:"",
			descripcion : traducir(resultado.descripcion_i18n)?traducir(resultado.descripcion_i18n):'',
			textoMeetingPoint : traducir(resultado.textoMeetingPoint_i18n)?traducir(resultado.textoMeetingPoint_i18n):'',
			coordenadas:resultado.coordenadas,
			boolLocalizacion:resultado.localizaciones,
			boolAreas:resultado.airport2Door,
			stopSales:resultado.stopSales,
			fechaInicioStopSales:resultado.fechaInicioStopSales,
			fechaFinStopSales:resultado.fechaFinStopSales,
			horasDePlazo:resultado.horasDePlazo,
			minutosDePlazo:resultado.minutosDePlazo,
			tipoDestino:"estacion",
			tarifas: listaTarifasTemp,
			tipoEstacion: resultado.tipoEstacion,
			textoBusqueda:resultado.textoBusqueda,
			url: traducir(resultado.url_i18n)?traducir(resultado.url_i18n):''

		}
		return aero;
	}

	//Sacar areas y localizaciones juntas
	/*
	export async function getAreasyLocalizaciones(){
		var areas= await getAreas();
		var localizaciones= await getLocalizaciones();
		var listaJunta=[];
		var listaAreas=[];
		var listaLocales=[];
		for await (let area of areas.items) {
			listaAreas.push(area);
		}

		for await (let localizacion of localizaciones.items) {
			if(!listaLocales.some(local => local.key === localizacion.key)){
				listaLocales.push({id:localizacion.id,nombre: localizacion.localizacionSelect.name, key:localizacion.localizacionSelect.key, coordenadas:localizacion.coordenadas, type:"location"});
			}
		}
		listaJunta={areas:listaAreas, localizaciones: listaLocales};
		return listaJunta;

	}*/

	export async function getDatosInicio(){
		var aeropuertos= await getAeropuertos();
		//var localizacionesJuntas= await getAreasyLocalizaciones();
		var traducciones= await getTraducciones();
		var configuraciones= await getConfiguracionesBuscador();
		var listaAreas= [];

		let listaRepetidos = [];
      	let listaPoligonos = [];

		logger(aeropuertos);
		//var listaAeroTarifas=await this.getListaAeropuertosConTodo(aeropuertos.items);
		var listaAeropuertos=[];
		aeropuertos.items.forEach((aero)=>{
			listaAeropuertos.push({
				id: aero.id,
				place_id:"",
				nombre: traducir(aero.nombre_i18n)?traducir(aero.nombre_i18n):'',
				descripcion : traducir(aero.descripcion_i18n)?traducir(aero.descripcion_i18n):'',
				textoMeetingPoint : traducir(aero.textoMeetingPoint_i18n)?traducir(aero.textoMeetingPoint_i18n):'',
				coordenadas:aero.coordenadas,
				boolLocalizacion:aero.localizaciones,
				boolAreas:aero.airport2Door,
				stopSales:aero.stopSales,
				fechaInicioStopSales:aero.fechaInicioStopSales,
				fechaFinStopSales:aero.fechaFinStopSales,
				horasDePlazo:aero.horasDePlazo,
				minutosDePlazo:aero.minutosDePlazo,
				tipoEstacion: aero.tipoEstacion,
				tipoDestino:"estacion",
				textoBusqueda:aero.textoBusqueda,
				url: traducir(aero.url_i18n)?traducir(aero.url_i18n):''
			});
		});
		listaAeropuertos=listaAeropuertos.sort((a, b) => a.nombre.localeCompare(b.nombre));
		logger(listaAeropuertos);

		//Variables url
		//http://localhost:8080/?aeropuertoId=45549&type=locationnombreDestino=Hotel%20Reconquista&fechaIda=2024-05-22T22:00:00.000Z&destination=hotelReconquista&pasajeros=1
		let query = usarQuery();
		var variables={
			aeropuertoId:parseInt(query.get('aeropuertoId')),
			type:query.get('type'),
			placeId:query.get('place_id'),
			nombreDestino:query.get('nombreDestino'),
			fechaIda:query.get('fechaIda'),
			fechaVuelta:query.get('fechaVuelta'),
			destination:query.get('destination'),
			pasajeros:{
				adultos:parseInt(query.get('pasajeros')),
				ninos:parseInt(query.get('ninos')),
				bebes:parseInt(query.get('bebes')),
			},
			origenNoAeropuerto: query.get('origenNoAeropuerto')
		}

		return {
			listaAeropuertos:listaAeropuertos,
			variables:variables,
			configuraciones:configuraciones,
			traducciones:traducciones,
			areas:listaPoligonos,
			areasOriginales:listaAreas.items
		}
	}

	

	export async function getDatosDestinoNested(elem, areas){

		var resAreas=await filtrarAreasPorCoordenadas(areas,elem.lat,elem.lon);
		let area= resAreas[0];
		
		//http://spaintransfers.es:8080/o/c/aeropuertos/66667003?nestedFields=aeropuerto,precioTarifasArea,precioTarifasLocalizacion,area,localizacion&nestedFieldsDepth=3
		var promesa= await api("o/c/areas/"+area.id+"?nestedFields=estacion,precioTarifasArea,area&nestedFieldsDepth=3")
		.catch((e) => console.error("Error en llamada tarifas: " + e));
		var resultado= await promesa.json();
		logger(resultado);

		let listaAeropuertos=[];
		for(let precioArea of resultado?.area){
			for (let tarifa of precioArea.precioTarifasArea) {
				for (let aero of tarifa.estacion) {
					if(!listaAeropuertos.some(aeropuerto => aeropuerto.id === aero.id)){
						listaAeropuertos.push({
							id: aero.id,
							place_id:"",
							nombre: traducir(aero.nombre_i18n)?traducir(aero.nombre_i18n):'',
							descripcion : traducir(aero.descripcion_i18n)?traducir(aero.descripcion_i18n):'',
							textoMeetingPoint : traducir(aero.textoMeetingPoint_i18n)?traducir(aero.textoMeetingPoint_i18n):'',
							coordenadas:aero.coordenadas,
							boolLocalizacion:aero.localizaciones,
							boolAreas:aero.airport2Door,
							stopSales:aero.stopSales,
							fechaInicioStopSales:aero.fechaInicioStopSales,
							fechaFinStopSales:aero.fechaFinStopSales,
							horasDePlazo:aero.horasDePlazo,
							minutosDePlazo:aero.minutosDePlazo,
							tipoDestino:"estacion",
							textoBusqueda:aero.textoBusqueda
						});
					}
				}
			}

		}

		return listaAeropuertos;
	}

	export async function validarOrigenDestino(origen, destino){
		let listaAreas=[];
		let valido=false;
		origen.tarifas.forEach((tarifa)=>{
			if(tarifa.areasConPrecios){
				tarifa.areasConPrecios?.forEach((area)=>{
					if(!listaAreas.some(a=>a.id===area.id)){
						listaAreas.push(area);
					}
				});
			}
		});

		let resAreas=await filtrarAreasPorCoordenadas(listaAreas,destino.lat,destino.lon);
		if(resAreas?.length>0){
			valido=true;
		} else{
			logger("Origen y destino no compatibles");
			valido=false;
		}
		return valido;

	}

	
const Llamadas = {
	traducir,
	getTraducciones,
	getAeropuertos,
	getTarifas,
	getApiKeyTomTom,
	getConfiguracionUrl,
	getImagenFondo,
	getUrlFormulario,
	getTarifasAeropuerto,
	getTarifasByPrecioArea,
	getLocalizacionById,
	getLocalizaciones,
	getAreas,
	getPrecioAreaByArea,
	getTodoAeropuertoNested,
	getDatosInicio,
	validarOrigenDestino
};

export default Llamadas;